import { PlatformCompat } from "@huyafed/huya-kiwi";

export const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

const ua = navigator?.userAgent?.toLowerCase?.() || "";

/** pc观众端 */
export const isPC = /huya-pc/.test(ua);

/** pc主播端 */
export const isPCAnchor = /hyanchor/.test(ua);

/** 虎牙助手端 */
export const isZSApp = /huya-zs/.test(ua);

/** 是否为鸿蒙移动端 */
export const isHarmonyOSMobile =
  /Harmony/i.test(navigator.userAgent) && /Mobile|Tablet/i.test(navigator.userAgent);

/** 是否为移动端设备 */
export const isMobile =
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
    navigator.userAgent,
  ) || isHarmonyOSMobile;

/**
 * @description 精准匹配字符串是否包含 `huya` 关键词，关键词前后可以是空格或什么都没有
 * - 测试用例
 * ```ts
    var userAgents = [
        "huya",
        "  huya  ",
        "Mozilla/5.0 huya ios",
        "Mozilla/5.0 huya-xixi asdalks",
        "huya xixi",
        "huya-xixi",
        "huyapc",
        "huyamini"
    ];
    var matched = userAgents.filter(ua => ua.trim().split(" ").includes("huya"));
    console.log(matched);
    // ['huya', '  huya  ', 'Mozilla/5.0 huya ios', 'huya xixi']
 * ```
 */
const hasHUYAKeyWord = navigator.userAgent.trim().split(" ").includes("huya");

/**
 * @description 是否为虎牙的app;仅适用虎牙观众端，小鹿
 */
export const isHUYAApp = isMobile && hasHUYAKeyWord;

export const isHUYAAdr = isHUYAApp && !isIOS;

export const getBrowserVersion = () => {
  var userAgent = navigator.userAgent;
  var chromeRegex = /Chrome\/([0-9.]+)/;
  var matches = userAgent.match(chromeRegex);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return "";
};

/**
 * [比较版本号大小]
 * version1 < version2 return -1
 * version1 > version2 return 1
 * version1 === version2 return 0
 */

export const versionCompare = (version1, version2) => {
  var v1 = version1.split(".");
  var v2 = version2.split(".");

  for (var i = 0; i < Math.max(v1.length, v2.length); i++) {
    var num1 = parseInt(v1[i]) || 0;
    var num2 = parseInt(v2[i]) || 0;

    if (num1 < num2) {
      return -1;
    } else if (num1 > num2) {
      return 1;
    }
  }

  return 0;
};

/**
 * @description 是否为 pc 观众端 miniblink内核
 */
export const isMiniBlinkWebViewInPC = (() => {
  const MIN_VERSION = "88";
  const browserVersion = getBrowserVersion();
  const isInMiniBlinkWebView = /huya-pc/gi.test(navigator.userAgent);
  const isVersionLess = versionCompare(browserVersion, MIN_VERSION) === -1;
  return isVersionLess && isInMiniBlinkWebView;
})();

type TCheckItem = "kiwi" | "pitaya" | "zs" | "pc_exe" | "pc_anchor";

/**
 * @description 严格判断当前环境
 * - kiwi: 虎牙观众端
 * - pitaya: 小鹿app
 * - zs: 虎牙助手端
 * - pc_exe: pc观众端
 * - pc_anchor: pc主播端
 * @example
 * ```ts
 * // 是否为虎牙观众端
 * const isKiwi = await checkIs('kiwi');
 * // 是否为虎牙助手端或pc主播端
 * const isZSOrPCAchor = await checkIs(['zs', 'pc_anchor']);
 * ```
 */
export async function checkIs(client: TCheckItem): Promise<boolean>;
export async function checkIs(client: TCheckItem[]): Promise<boolean>;
export async function checkIs(client: TCheckItem | TCheckItem[]) {
  const platform = await PlatformCompat.getPlatformOS();
  const checkItem = (item: TCheckItem) =>
    item === "pc_exe" ? platform === "pc_exe" || platform === "pc_exe_external" : platform === item;
  return Array.isArray(client) ? client.some(item => checkItem(item)) : checkItem(client);
}
